module.exports = __webpack_public_path__ + "static/media/piechartDemo.e56116fa.png";